import React from "react";
import { Link } from "react-router-dom";
import { useLang, localized } from "@/i18n";
import { ArrowUpRight, Star, Clock } from "lucide-react";

export default function TourCard({ tour, index = 0, linkQuery = "" }) {
  const { lang, t } = useLang();
  const label = tour.label ? localized(tour.label, lang) : null;
  const price = tour.price_mxn > 0 ? `MX$${tour.price_mxn.toLocaleString()}` : t("tours.consult");

  return (
    <Link
      to={`/tours/${tour.slug}${linkQuery}`}
      data-testid={`tour-card-${tour.slug}`}
      className="group relative flex flex-col bg-[#0C1310] border border-[#1E2B25] hover:border-[#C4A661]/50 transition-colors duration-500 overflow-hidden h-full"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={tour.hero_image}
          alt={localized(tour.name, lang)}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050908]/90 via-[#050908]/15 to-transparent" />
        {label && (
          <span className="absolute top-4 left-4 px-3 py-1.5 bg-[#C4A661] text-[#050908] text-[10px] tracking-[0.22em] uppercase font-semibold">
            {label}
          </span>
        )}
        <div className="absolute bottom-5 left-5 right-5">
          <div className="flex items-center gap-1.5 text-[#C4A661]" data-testid={`tour-rating-${tour.slug}`}>
            {Array.from({ length: 5 }).map((_, k) => (
              <Star key={k} size={12} fill="currentColor" strokeWidth={0} />
            ))}
            <span className="text-[11px] text-[#F5F2EA]/70 ml-1">5.0</span>
          </div>
          <p className="eyebrow !text-[#F5F2EA]/70 mt-2">{localized(tour.location, lang)}</p>
          <h3 className="font-serif-hc text-2xl md:text-[27px] leading-tight text-[#F5F2EA] mt-1">
            {localized(tour.name, lang)}
          </h3>
        </div>
      </div>

      <div className="px-5 py-4 flex items-end justify-between gap-4">
        <div>
          <p className="flex items-center gap-1.5 text-[10px] tracking-[0.22em] uppercase text-[#A3A095]">
            <Clock size={11} /> {localized(tour.duration, lang)}
          </p>
          <p className="font-serif-hc text-xl text-[#C4A661] mt-1.5">
            <span className="text-[10px] tracking-[0.22em] uppercase text-[#A3A095] mr-1.5">{t("tours.from")}</span>
            {price}
          </p>
        </div>
        <span className="inline-flex items-center gap-1 pb-1 text-[11px] tracking-[0.22em] uppercase text-[#F5F2EA] group-hover:text-[#C4A661] transition-colors whitespace-nowrap">
          {t("tours.see")} <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </div>
    </Link>
  );
}
